import Page from './Page';
import reducer from './reducer';

export const reducers = { AccountCategoryManager: reducer };

export default { Page, reducers };